@use "variables" as *;

.visibility {
  font-size: $fontSize-xs;
  padding: $spacing-xs;
  margin: $spacing-xs;
  border-radius: 16px;
  align-self: end;
}

.nameContainer {
  height: 60px;
  margin-bottom: $spacing-xs;
}

.card {
  justify-content: flex-start !important;
  min-width: 164px;
  min-height: 124px;
  height: 100%;
  border-radius: 20px !important;
}

.image {
  height: 60px;
  width: 100%;
  align-self: flex-start !important;
  background-color: transparent;
  position: absolute;
  filter: brightness(70%);
}

.nameStack {
  position: absolute;
  width: 100%;
  z-index: 2;
}

.name {
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 1);
  flex-shrink: 1;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: $fontSize-m;
  font-weight: bold;
  color: white;
  margin: $spacing-xs $spacing-xs $spacing-xs $spacing-s;
}

.description {
  font-size: $fontSize-xs;
  font-weight: lighter;
  margin-left: $spacing-s;
  align-self: flex-start;
  overflow: hidden;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  flex-shrink: 1;
}

.bottomStack {
  width: 100%;
  align-items: center;
}

.collectionStats {
  padding-right: $spacing-xs;
}

.discountBox {
  margin: $spacing-xs $spacing-s $spacing-xs $spacing-xs;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.4);
  flex-shrink: 0;
}
